import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllGames() {
  try {
    const response = await fetch(base + 'games');
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllGames', error);
    throw error;
  }
}

export async function getGame(g) {
  try {
    const response = await fetch(base + "games/" + g);
    return await response.json();
  } catch (error) {
    console.error('Erreur getGame', error);
    throw error;
  }
}
  
export async function createGame(gameName) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'games/insert', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ nom: gameName }),
    });
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur createGame', error);
    throw error;
  }
}

// export async function updateGame(gameId, gameName) {
//   try {
//     const authToken = localStorage.getItem("authToken");
//     const response = await fetch(base + 'games/update', {
//       method: 'POST',
//       credentials: "include",
//       headers: { 
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${authToken}` 
//       },
//       body: JSON.stringify({ id: gameId, nom: gameName }),
//     });
//     return await response.json();
//   } catch (error) {
//     if (debug) console.error('Erreur updateGame', error);
//     throw error;
//   }
// }

export async function updateGame(gameId, payload) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'games/update', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ id: gameId, ...payload }),
    });
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur updateGame', error);
    throw error;
  }
}

export async function deleteGame(gameId) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'games/delete', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ id: gameId }),
    });
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur deleteGame', error);
    throw error;
  }
}

export async function regenCode(gameId) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'games/regen', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ id: gameId })
    });
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur lors de la régénération du code', error);
    throw error;
  }
}

/**
 * Mettre à jour l'image
 */
export async function updateGameImage(id, image) {
    try {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('image', image);

        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + "games/update-image", {
        method: 'POST',
        headers: { 
            'Authorization': `Bearer ${authToken}` 
        },
        body: formData
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur updateGameImage:', error);
        throw error;
    }
}

/**
 * Supprimer l'image
 */
export async function deleteGameImage(id, image) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "games/delete-image", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, image })
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteGameImage:', error);
        throw error;
    }
}
  